<template>
    <div>
        <div class="container mt-4 mb-4">
            <!-- <atras-component></atras-component> -->
            <boton-atras :nombre_ruta="'manuales-administrativos'"></boton-atras>
            <div class="row">
                <div class="col-md  mt-1 order-2 order-sm-2 order-md-1 order-lg-1">
                    <h6 class="subtitulo mb-2 textoFijo">Manual de Organización</h6>
                    <div class="lineaNegra"></div>
                    <div class="mt-1 mb-2 lineaNegra2"></div>
                    <!-- AREA DE DOCUMENTOS CON CARDS-->
                    <a :href="urlServe+'conocenos/informacion/m-organizacion/1-Portada.pdf'" target="_blank">
                        <div class="mb-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Portada </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                     <!--  -->
                    <a :href="urlServe+'/conocenos/informacion/m-organizacion/2-Indice.pdf'" target="_blank">
                        <div class="mb-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Índice </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <!--  -->
                    <a :href="urlServe+'conocenos/informacion/m-organizacion/3-Autorizacion.pdf'" target="_blank">
                        <div class="my-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Autorización </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <!--  -->
                    <a :href="urlServe+'conocenos/informacion/m-organizacion/4-Introduccion.pdf'" target="_blank">
                        <div class="my-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Introducción </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <!--  -->
                    <a :href="urlServe+'conocenos/informacion/m-organizacion/5-Antecedentes.pdf'" target="_blank">
                        <div class="my-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                     <h5> Antecedentes </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <!--  -->
                    <a :href="urlServe+'conocenos/informacion/m-organizacion/6-Marco-Normativo-Aplicable.pdf'" target="_blank">
                        <div class="my-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Marco Normativo Aplicable </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <!--  -->
                    <a :href="urlServe+'conocenos/informacion/m-organizacion/7-Mision.pdf'" target="_blank">
                        <div class="my-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Misión  </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <!--  -->
                    <a :href="urlServe+'conocenos/informacion/m-organizacion/8_Vision.pdf'" target="_blank">
                        <div class="my-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Visión </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a> 
                    <!--  -->
                     <a :href="urlServe+'conocenos/informacion/m-organizacion/9-Org-Func.pdf'" target="_blank">
                        <div class="my-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Organigramas y Funciones </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>

                    <a :href="urlServe+'conocenos/informacion/m-organizacion/10-Ofic-Secretario.PDF'" target="_blank">
                        <div class="mb-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Oficina del C. Secretario </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a> 
                    <!--  -->
                   <!-- <a :href="urlServe+'conocenos/informacion/m-organizacion/8-Ofic-Secretario.pdf'" target="_blank">
                        <div class="mb-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Oficina del C. Secretario </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>-->
                    <!--  -->
                    <!--  -->
                    <a :href="urlServe+'conocenos/informacion/m-organizacion/11-U-Apoyo-Advo.pdf'" target="_blank">
                        <div class="mb-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Unidad de Apoyo Administrativo </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <!--  -->
                    <a :href="urlServe+'conocenos/informacion/m-organizacion/12-U-Informatica.PDF'" target="_blank">
                        <div class="mb-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Unidad de Informática </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <!--  -->
                    <a :href="urlServe+'conocenos/informacion/m-organizacion/13-U-Planeacion.PDF'" target="_blank">
                        <div class="mb-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Unidad de Planeación </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <!--  -->
                    <a :href="urlServe+'conocenos/informacion/m-organizacion/14-U-Coord-Adva-Organis-Pub.PDF'" target="_blank">
                        <div class="mb-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Unidad de Coordinación Administrativa de Organismos Públicos </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <!--  -->
                    <a :href="urlServe+'conocenos/informacion/m-organizacion/15-U-Tecnica.PDF'" target="_blank">
                        <div class="mb-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Unidad Técnica </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <!--  -->
                    <a :href="urlServe+'conocenos/informacion/m-organizacion/16-U-Intelig-Patrim-Economica.PDF'" target="_blank">
                        <div class="mb-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Unidad de Inteligencia Patrimonial y Económica </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <!--  -->
                    <!--  -->
                    <a :href="urlServe+'conocenos/informacion/m-organizacion/17-U-Transparencia.PDF'" target="_blank">
                        <div class="mb-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Unidad de Transparencia </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <!--  -->
                    <a :href="urlServe+'conocenos/informacion/m-organizacion/18-U-Vincul-Atenc-Audito.PDF'" target="_blank">
                        <div class="mb-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Unidad de Vinculación de Atención a Auditorías </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <!--  -->
                    <a :href="urlServe+'conocenos/informacion/m-organizacion/19-U-Archivo.PDF'" target="_blank">
                        <div class="mb-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Unidad de Archivo </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <!--  -->
                    <a :href="urlServe+'conocenos/informacion/m-organizacion/20-Sub-Planeacion.PDF'" target="_blank">
                        <div class="mb-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Subsecretaría de Planeación </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <!--  -->
                     <!--  -->
                    <a :href="urlServe+'conocenos/informacion/m-organizacion/21-Dir-Informa-Geog-Estadistica.PDF'" target="_blank">
                        <div class="mb-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Dirección de Información Geográfica y Estadística </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <!--  -->
                    <!--  -->
                    <a :href="urlServe+'conocenos/informacion/m-organizacion/22-Dir-Fortal-Mpal-Des-Regional.PDF'" target="_blank">
                        <div class="mb-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Dirección de Fortalecimiento Municipal y Desarrollo Regional </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <!--  -->
                    <a :href="urlServe+'conocenos/informacion/m-organizacion/23-Dir-Planea-Programa.PDF'" target="_blank">
                        <div class="mb-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Dirección de Planeación y Programación </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <!--  -->
                    <a :href="urlServe+'conocenos/informacion/m-organizacion/24-Dir-Gestion-Evalu-Proyectos.PDF'" target="_blank">
                        <div class="mb-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Dirección de Gestión y Evaluación de Proyectos </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <!--  -->
                    <a :href="urlServe+'conocenos/informacion/m-organizacion/25-Sub-Egresos.PDF'" target="_blank">
                        <div class="mb-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Subsecretaría de Egresos </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <!--  -->
                    <!--  -->
                    <a :href="urlServe+'conocenos/informacion/m-organizacion/26-Dir-Presup-Gasto-Instituc.PDF'" target="_blank">
                        <div class="mb-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Dirección de Presupuesto del Gasto Institucional </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <!--  -->
                    <!--  -->
                    <a :href="urlServe+'conocenos/informacion/m-organizacion/27-Di-Presup-Gast-Inversion.PDF'" target="_blank">
                        <div class="mb-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Dirección de Presupuesto del Gasto de Inversión </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <!--  -->
                    <a :href="urlServe+'conocenos/informacion/m-organizacion/28-Dir-Pol-Gasto.PDF'" target="_blank">
                        <div class="mb-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Dirección de Política del Gasto </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <!--  -->
                    <a :href="urlServe+'conocenos/informacion/m-organizacion/29-Dir-Conta-Gubernam.PDF'" target="_blank">
                        <div class="mb-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Dirección de Contabilidad Gubernamental </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <!--  -->
                    <a :href="urlServe+'conocenos/informacion/m-organizacion/30-Sub-Ingresos.PDF'" target="_blank">
                        <div class="mb-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Subsecretaría de Ingresos </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <!--  -->
                    <!--  -->
                    <a :href="urlServe+'conocenos/informacion/m-organizacion/31-Area-Prog-Espec-Evalua-Operativa.PDF'" target="_blank">
                        <div class="mb-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Área de Programas Especiales y Evaluación Operativa </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <!--  -->
                    <!--  -->
                    <a :href="urlServe+'conocenos/informacion/m-organizacion/32-Dir-Ingresos.PDF'" target="_blank">
                        <div class="mb-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Dirección de Ingresos </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <!--  -->
                    <a :href="urlServe+'conocenos/informacion/m-organizacion/33-Dir-Audit-Fiscal.PDF'" target="_blank">
                        <div class="mb-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Dirección de Auditoría Fiscal </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <!--  -->
                    <a :href="urlServe+'conocenos/informacion/m-organizacion/34-Dir-Cobranza.PDF'" target="_blank">
                        <div class="mb-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Dirección de Cobranza </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <!--  -->
                    <a :href="urlServe+'conocenos/informacion/m-organizacion/35-Del-Hacienda.PDF'" target="_blank">
                        <div class="mb-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5>Delegaciones de Hacienda</h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <!--  -->
                     <!--  -->
                    <a :href="urlServe+'conocenos/informacion/m-organizacion/36-Tesor-unica.PDF'" target="_blank">
                        <div class="mb-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Tesorería Única </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <!--  -->
                    <!--  -->
                    <a :href="urlServe+'conocenos/informacion/m-organizacion/37-Area-Gest-Finanzas-Inver.PDF'" target="_blank">
                        <div class="mb-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Área de Gestión de Finanzas e Inversiones </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <!--  -->
                    <a :href="urlServe+'conocenos/informacion/m-organizacion/38-Dir-Coord-Mpal-Financ-Pub.PDF'" target="_blank">
                        <div class="mb-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Dirección de Atención Municipal y Deuda Pública </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <!--  -->
                    <a :href="urlServe+'conocenos/informacion/m-organizacion/39-Dir-Control-Financ.PDF'" target="_blank">
                        <div class="mb-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Dirección de Control Financiero </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <!--  -->
                    <a :href="urlServe+'conocenos/informacion/m-organizacion/40-Dire-Pagos.PDF'" target="_blank">
                        <div class="mb-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Dirección de Pagos </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <!--  -->
                    <!--  -->
                    <a :href="urlServe+'conocenos/informacion/m-organizacion/41-Coord-Gral-Rec-Humanos.PDF'" target="_blank">
                        <div class="mb-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Coordinación General de Recursos Humanos </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <!--  -->
                    <!--  -->
                    <a :href="urlServe+'conocenos/informacion/m-organizacion/42-Dir-Estruct-Org.PDF'" target="_blank">
                        <div class="mb-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Dirección de Estructuras Orgánicas </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <!--  -->
                    <a :href="urlServe+'conocenos/informacion/m-organizacion/43-Dir-Evalua-Formacion.PDF'" target="_blank">
                        <div class="mb-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Dirección de Evaluación y Formación </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <!--  -->
                    <a :href="urlServe+'conocenos/informacion/m-organizacion/44-Dir-Admon-Personal.PDF'" target="_blank">
                        <div class="mb-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Dirección de Administración de Personal </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <!--  -->
                    <a :href="urlServe+'conocenos/informacion/m-organizacion/45-Dir-Oblig-Fisc-Retenciones.PDF'" target="_blank">
                        <div class="mb-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Dirección de Obligaciones Fiscales y Retenciones </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <!--  -->
                     <!--  -->
                    <a :href="urlServe+'conocenos/informacion/m-organizacion/46-Dir-Gest-Adva-Educativa.PDF'" target="_blank">
                        <div class="mb-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Dirección de Gestión Administrativa y Educativa </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <!--  -->
                    <a :href="urlServe+'conocenos/informacion/m-organizacion/47-Procu-Fiscal.PDF'" target="_blank">
                        <div class="mb-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Procuraduría Fiscal </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <!--  -->
                    <a :href="urlServe+'conocenos/informacion/m-organizacion/48-Subp-Legisla-Asuntos-Jur.PDF'" target="_blank">
                        <div class="mb-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Subprocuraduría de Legislación y Asuntos Jurídicos </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <!--  -->
                    <a :href="urlServe+'conocenos/informacion/m-organizacion/49-Sub-Resolu-Contencioso.PDF'" target="_blank">
                        <div class="mb-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Subprocuraduría de Resoluciones y de lo Contencioso </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <!--  -->
                    <!--  -->
                    <a :href="urlServe+'conocenos/informacion/m-organizacion/50-Dir-Fideico-Entidades.PDF'" target="_blank">
                        <div class="mb-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Dirección de Fideicomisos y Entidades </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <!--  -->
                    <!--  -->
                    <a :href="urlServe+'conocenos/informacion/m-organizacion/51-Glosario-Terminos.PDF'" target="_blank">
                        <div class="mb-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Glosario de Términos </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <!--  -->
                    <a :href="urlServe+'conocenos/informacion/m-organizacion/52-Grupo-Trabajo.PDF'" target="_blank">
                        <div class="mb-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Grupo de Trabajo </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>
                    <!--  -->
                    <a :href="urlServe+'conocenos/informacion/m-organizacion/53-Contraportada.PDF'" target="_blank">
                        <div class="mb-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Contraportada </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>

                    <!-- <a :href="urlServe+'conocenos/informacion/m-organizacion/54_Dir_Org_Empresas_Pub.PDF'" target="_blank">
                        <div class="mb-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Dirección de Organismos y Empresas Públicas </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>

                    <a :href="urlServe+'conocenos/informacion/m-organizacion/55_Glosario_Terminos.PDF'" target="_blank">
                        <div class="mb-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Glosario de Términos </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>

                    <a :href="urlServe+'conocenos/informacion/m-organizacion/56_Grupo_Trabajo.PDF'" target="_blank">
                        <div class="mb-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Grupo de Trabajo </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a>

                    <a :href="urlServe+'conocenos/informacion/m-organizacion/57_Contraportada.pdf'" target="_blank">
                        <div class="mb-2">
                            <div class="area_document" style="display:flex; justify-content:space-between;">
                                <div class="col-8">
                                    <h5> Contraportada </h5>
                                </div>
                                <div class="col-3">
                                    <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                                </div>
                            </div>
                        </div>
                    </a> -->

                     <!-- }
                            Unidad -> 7
                            Coordinación -> 4
                            Dirección -> 23
                            Subsecretaría -> 4
                            ***los que son unicos:
                            Delegaciones de Hacienda
                            Tesorería Única
                            Área de Gestión de Finanzas e Inversiones
                             -->

                </div>

                <div class="col-md order-1 order-sm-1 order-md-2 order-lg-2">
                    <div class="row margenes img_fija">
                        <div class="sec_imagen">
                            <img src="@/assets/imagenes/reglamentoInterno.png" alt="">
                        </div>
                    </div>


                </div>
            </div>
        </div>
    </div>
</template>

<script>
import atrasComponent from './../../reload.vue'
import botonAtras from './../../button-atras'

export default {
    mounted(){
        window.scrollTo(0, 0);
    },
    components:{
        atrasComponent,
        botonAtras,
    }
}
</script>

<style scoped>
    .area_document {
        padding: .3rem 0;
        width: 100%;
        height: auto;
        border: 1px solid#dfdfdf ;
        border-radius: 5px;
        border-left: 3px solid #621132;

        display: flex;
        justify-content: space-between;
        align-items: center !important;

    }

    .area_document:hover{
        box-shadow: 3px 8px 17px -13px rgba(0,0,0,0.75) !important;
    }

    .descargar{
        font-size: 0.9rem;
        color: #6c757d !important;
    }

    .subtitulo {
        font-weight: 400;
        font-size: 1.8rem;
        margin-top: 1rem;
    }
    .subtitulo2{
        font-weight: 400;
        font-size: 1.2rem;
        margin-top: .5rem;
        margin-bottom: 1rem ;
    }
    .area_document h5{
        margin-bottom: 0;
        font-size: 0.9rem;
        font-weight: 400;
        /* line-height: 20px; */
    }
    .area_document p{
        margin-bottom: 0;
        margin-top: 0;

    }

    .sec_imagen{
        width:85% !important;
        background-color: #560F2C;
        /* margin-top: 3rem; */ /***quite por el btn atras* */

    }

    a{
        text-decoration: none !important;
        color: #212529;
    }
    a:hover{ color:#212529 !important; }

    /* margenes de la card consulta */
    .margenes{
        display: flex;
        justify-content: flex-end;
    }
    .card-width{ width: 90%; }

    /* select */
    .form-control-lg {
        font-size: 1rem;
        border-radius: .4rem;
    }

    /* imagen fija */
    .img_fija{
        position: sticky !important;
        top: 7% !important;
        z-index: 1000 !important;
    }
    /* CHECAR PARA QUE QUEDE EL TEXTO FIJO */
    /* .textoFijo{
        position: sticky !important;
        top: 15% !important;
        z-index: 1000 !important;
    } */

@media only screen and (max-device-width : 900px) {
    .container{
        padding-right: 1% !important;
        padding-left: 1% !important;
    }
    .area_document{
        padding: .5rem 1rem .5rem .1rem;
        line-height: 20px;
    }

    /* margenes de la card consulta */
    .margenes{ justify-content: space-around; }
    .card-width{ width: 95%; }

    .subtitulo2{ font-size: 1rem; }

    .sec_imagen{ margin-top: 0rem; }
}

</style>
